import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  transactionID: null,
  paymentPortal: null,
};

const paymentSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {
    setPaymentData: (state, action) => {
      state.transactionID = action.payload.transactionID;
      state.paymentPortal = action.payload.paymentPortal;
    },
    clearPaymentData: (state) => {
      state.transactionID = null;
      state.paymentPortal = null;
    },
  },
});

export const { setPaymentData, clearPaymentData } = paymentSlice.actions;
export default paymentSlice.reducer;
